module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb-wls.svg?2d554424b763bed9142fba7aaf41d8fc";